// 页面前进后退 缓存清楚
const clearKeepAlive = {
  beforeRouteLeave: (to, from, next) => {
    if (from.meta.clearKeepAlivePath.includes(to.path)) { 
      to.meta.exclude = from.name
    }else{
      to.meta.exclude = []
    }
    next()
  },
}
export default clearKeepAlive
